<template>
  <div :class="element.class" class="multi-line">
    <div v-for="line in element.elements" class="line">
      <text-with-refs :text="line.text"/>
    </div>
  </div>
</template>
<script>
  import TextWithRefs from './TextWithRefs'

  export default {
    components: {TextWithRefs},
    props: {
      element: {type: Object, required: true}
    }
  }
</script>
<style lang="scss" scoped>
  @import "app/javascript/scss/variables";

  .multi-line {
    margin: .5rem 0 .5rem #{$character-name-width + $character-name-separation};
    position: relative;
  }

  .StanzaStageDirection,
  .JourneyStageDirection {
    font-style: italic;
  }
</style>